import React from 'react';

const TwitterLogo = ({ ...props }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M27.8945 10C29.0664 9.13462 30.1211 8.09615 31 6.82692C29.8281 7.34615 28.6562 7.69231 27.4844 7.80769C28.7734 7 29.7109 5.90385 30.1797 4.46154C28.9492 5.15385 27.6602 5.67308 26.2539 5.90385C25.668 5.32692 24.9648 4.86538 24.2031 4.51923C23.4414 4.17308 22.6211 4 21.7422 4C20.6289 4 19.6328 4.28846 18.6953 4.80769C17.7578 5.38462 16.9961 6.13462 16.4687 7.05769C15.8828 7.98077 15.6484 9.01923 15.6484 10.0577C15.6484 10.5192 15.6484 10.9808 15.7656 11.4423C13.2461 11.3269 10.9023 10.75 8.67578 9.59615C6.44922 8.5 4.63281 7 3.10938 5.09615C2.52344 6.07692 2.23047 7.11538 2.23047 8.15385C2.23047 9.19231 2.46484 10.1731 2.99219 11.0385C3.46094 11.9615 4.16406 12.6538 4.98437 13.2308C3.98828 13.2308 3.05078 12.9423 2.23047 12.4231V12.5385C2.23047 13.9808 2.69922 15.25 3.63672 16.3462C4.57422 17.5 5.74609 18.1923 7.15234 18.4808C6.56641 18.5962 6.03906 18.6538 5.51172 18.6538C5.16016 18.6538 4.75 18.6538 4.39844 18.5962C4.75 19.8077 5.45312 20.7885 6.50781 21.5962C7.5625 22.4038 8.73437 22.75 10.1406 22.75C7.85547 24.4808 5.27734 25.3462 2.46484 25.3462C1.87891 25.3462 1.41016 25.3462 1 25.2885C3.8125 27.1346 6.97656 28 10.4336 28C14.0078 28 17.1719 27.1346 19.9844 25.2885C22.5039 23.6731 24.4961 21.5385 25.9023 18.7692C27.25 16.2308 27.9531 13.5192 27.9531 10.75C27.9531 10.4038 27.8945 10.1731 27.8945 10Z"
      fill="#003E7D"
    />
  </svg>
);

export default TwitterLogo;
